<template>
  <div style="max-width: 100% !important; margin: auto;">
    <div class="ma-auto">
      <div class="d-flex align-center my-4">
        <h3 style="margin-right: 15px;">تاکسی 133</h3>
      </div>
    </div>
    <div class="page-f">
     <v-container>
              
         <p class="text-center ">
         <img src="@/assets/images/cash-icon.png" style="width: 150px; margin-top: 50px; border-radius: 5px">
       </p>
       <h3 class="text-center my-5">مبلغ پرداخت خود را به تومان وارد کنید</h3>
       
      <v-container>
      <v-form
      ref="form"

      lazy-validation
    >
        <v-text-field
        required
        outlined
        grey
        v-model="money"
        type="number"
      ></v-text-field>

      <v-btn
          @click="BtnCharge"
        color="purple"
        style="width:100%; text-align: center; height: 50px; color:white; font-size:20px;"
      >
        افزایش اعتبار
      </v-btn>


    </v-form>
    </v-container>
       <v-snackbar
           color="red"
           style="z-index: 1050"
           v-model="snackbar"
       >
         {{ text }}
         <template v-slot:action="{ attrs }">
           <v-btn
               color="white"
               text
               v-bind="attrs"
               @click="snackbar = false"
           >
             بستن
           </v-btn>
         </template>
       </v-snackbar>

     </v-container>
    </div>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>
</template>

<script>
import SocketListner from "../components/SocketListner.vue";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
export default {
  components: {
    SocketListner,
    AndroidGeolocation,
   },
  data(){
    return{
      userBox: '',
      money: '',
      setState : '',
      time : '',
      text : 'اعتبار شما کافی نمی باشد',
      snackbar: false,
    }
  },
  mounted() {
    let self = this;
    self.getInfo();
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },
  methods:{
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
    },
    async BtnCharge() {
      var price = this.money.split(',').join('');
      if (this.money == '') {
        this.snackbar = true
        this.text = 'مبلغ مورد نظر را وارد کنید'
      } else {
        let response = await fetch(this.baseUrl + '/charge-driver-credit', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            public_token: this.userBox.public_token,
            uid: this.userBox.uid,
            price: price,
          })
        });
        let json = await response.json();
        console.log(json);

        if (json.result === 1) {
          var url = json.data.url;
          window.location.href = url;
        } else if (json.result === 0) {
          // Validate
          this.snackbar = true
          this.text = json.msg;
        }
      }
    },
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    SocketListner.disconnect();
  },
};
</script>

<style scoped>
.page-f{
  height: calc(100vh - 116px);
  overflow: auto;

}
</style>
